import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false
};
var getAllMapsSlice = createSlice({
    name: "getAllMaps",
    initialState: initialState,
    reducers: {
        fetchData: function(state) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
        },
        fetchDataSuccess: function(state, action) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                data: action.payload
            });
        },
        fetchDataFailure: function(state) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isError: true
            });
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _getAllMapsSlice_actions = getAllMapsSlice.actions;
export var fetchData = _getAllMapsSlice_actions.fetchData, fetchDataSuccess = _getAllMapsSlice_actions.fetchDataSuccess, fetchDataFailure = _getAllMapsSlice_actions.fetchDataFailure, resetState = _getAllMapsSlice_actions.resetState;
export default getAllMapsSlice.reducer;
